import React, { useEffect, useState } from 'react';
import SEO from '../utils/SEO';
import { userActions } from '../redux/actions';
import { connect } from 'react-redux';
import { animateScroll } from 'react-scroll';
import AboutBannerBlock from '../components/complex/aboutBannerBlock/aboutBannerBlock';
import AboutSlider from '../components/complex/aboutSlider/aboutSlider';
import AboutOrganizersBlock from '../components/complex/aboutOrganizersBlock/aboutOrganizersBlock';
import AboutComposerResidence from '../components/complex/aboutComposerResidence/aboutComposerResidence';
import '../assets/styles/pages/_about.scss';
import { useLocation } from 'react-router';
import { startLoader } from '../components/common/Loader';

function About ({ getAboutData, ...props }) {
  const location = useLocation();
  const [dataReady, setDataReady] = useState(null);

  useEffect(() => {
    props.getMeta('About');
    startLoader();
    getAboutData()
      .then((res) => {
        return res.res;
      })
      .then((e) => {
        e && setDataReady(true);
      });
  }, [getAboutData]);

  function scrollToElement (offsetBanner) {
    const params = new URL(document.location);
    const activeLink = params.searchParams.get('active');
    const windowHeight = offsetBanner ? window.innerHeight : 0;
    const headLine = document.getElementById('headLine').clientHeight;

    if (activeLink) {
      const pos =
        document.getElementById(activeLink) &&
        document.getElementById(activeLink).offsetTop + windowHeight - headLine;
      animateScroll.scrollTo(pos, { duration: 1500 });
    }
  }

  useEffect(() => {
    dataReady && scrollToElement(null);
    const whiteLayer =
      document &&
      document.getElementById('whiteLayer') &&
      document.getElementById('whiteLayer');
    whiteLayer &&
      setTimeout(() => {
        whiteLayer.classList.remove('show');
      }, 1000);
  }, [location.search, dataReady]);

  const metaData = props.metaData?.res;
  const banner = props.aboutData?.items?.banner;
  const slider = props.aboutData?.items?.timeline;
  const organizers = props.aboutData?.items?.organizers;
  const residence = props.aboutData?.items?.composer_in_residence;

  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />

      <AboutBannerBlock banner={banner && banner} />
      <AboutSlider sliderData={slider} />
      <AboutOrganizersBlock organizerData={organizers} />
      <AboutComposerResidence residence={residence} />
    </>
  );
}

function mapState (state) {
  return {
    aboutData: state.getAboutData,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getAboutData: userActions.getAboutData,
  getMeta: userActions.getMetaData,
};
About.fetchMeta = () => actionCreators.getMeta('About');
About.serverFetch = actionCreators.getAboutData;

export default connect(mapState, actionCreators)(About);
